import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { TBusyValue } from "../BusyComboBox/BusyComboBox.utils";

export interface FilterState {
  tags: tagList;
  busy: TBusyValue[];
}

const initialState: FilterState = {
  tags: [],
  busy: [],
};

export const filterSlice = createSlice({
  name: "Filter",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    changeTagList: (state, action: PayloadAction<tagList>) => {
      state.tags = action.payload;
    },
    addTagToList: (state, action: PayloadAction<tagListItem>) => {
      state.tags.push(action.payload);
    },
    changeBusyList: (state, action: PayloadAction<TBusyValue[]>) => {
      state.busy = action.payload;
    },
    // addBusyToList: (state, action: PayloadAction<string>) => {
    //   state.busy.push(action.payload);
    // },
  },
});

export const { changeTagList, addTagToList, changeBusyList } =
  filterSlice.actions;

export const selectFilterTags = (state: RootState) => state.filter.tags;
export const selectFilterBusy = (state: RootState) => state.filter.busy;

export default filterSlice.reducer;
